export const GET_CALL_STATUSES_METRICS = gql`
  query GetCallStatusesMetrics($filters: CallLogFiltersInput) {
    callStatusesMetrics(filters: $filters) {
      callStatus
      date
      count
    }
  }
`

export const GET_TOTAL_CALL_DURATION_METRIC = gql`
  query GetTotalCallDurationMetric($filters: CallLogFiltersInput) {
    getTotalCallDurationMetric(filters: $filters) {
      callDirection
      duration
    }
  }
`

export const GET_CALL_DURATION_AVERAGE_METRIC = gql`
  query GetCallDurationAverageMetric($filters: CallLogFiltersInput) {
    getCallDurationAverageMetric(filters: $filters) {
      averageDuration
    }
  }
`

export const GET_APPLICANT_CALL_CONVERSION_BY_STATUS = gql`
  query GetApplicantCallConversionByStatus($filters: CallLogFiltersInput) {
    getApplicantCallConversionByStatus(filters: $filters) {
      total
      statuses {
        status
        connectedStatus
        count
        percentage
      }
    }
  }
`

export const GET_AVERAGE_CALL_COUNT_METRIC = gql`
  query GetAverageCallCountMetric($filters: CallLogFiltersInput) {
    getAverageCallCountMetric(filters: $filters) {
      averageCallCount
    }
  }
`

export const GET_APPLICANT_CALL_CONVERSION_LIST = gql`
  query GetApplicantCallConversionList(
    $filters: CallLogFiltersInput
    $pageInfo: PageInfoInput
  ) {
    getApplicantCallConversionList(filters: $filters, pageInfo: $pageInfo) {
      totalCount
      items {
        applicantCallConversionId
        initialCallDate
        lastCallDate
        status
        callCount
        connectedStatus
        firstName
        lastName
        phoneNumber
        applicant {
          applicantId
          firstName
          middleName
          lastName
          phone
        }
      }
    }
  }
`
export const GET_COMMON_DISCUSSION_TOPICS = gql`
  query GetCommonDiscussionTopics($filters: CallLogFiltersInput) {
    getCommonDiscussionTopics(filters: $filters) {
      topic
      frequency
    }
  }
`

export const GET_VOICE_AGENT_CALL_METRICS = gql`
  query GetVoiceAgentCallMetrics($filters: CallLogFiltersInput) {
    getVoiceAgentCallMetrics(filters: $filters) {
      totalConnectedCalls
      totalCallsWithAnalysis
    }
  }
`

export const GET_CALL_ACTIVITY_BY_EMPLOYEE = gql`
  query GetCallActivityByEmployee($filters: CallLogFiltersInput) {
    callActivityByEmployee(filters: $filters) {
      total
      items {
        rowId
        rowName
        isVoiceAgent
        completed
        noAnswer
        busy
        leftVoicemail
        failed
        total
        avgDurationSeconds
        totalDurationSeconds
      }
    }
  }
`

export const GET_CALL_VOLUME = gql`
  query GetCallVolume($input: CallVolumeInput!) {
    callVolume(input: $input) {
      bucket
      series {
        direction
        points {
          periodStart
          count
        }
      }
    }
  }
`

export const GET_CALL_ANALYTICS_HERO_STATS = gql`
  query GetCallAnalyticsHeroStats($filters: CallLogFiltersInput) {
    callAnalyticsHeroStats(filters: $filters) {
      current {
        totalCalls
        outboundCalls
        inboundCalls
        avgDurationSeconds
        aiCalls
        timeSavedSeconds
      }
      previous {
        totalCalls
        outboundCalls
        inboundCalls
        avgDurationSeconds
        aiCalls
        timeSavedSeconds
      }
    }
  }
`

export const GET_VOICE_AGENT_HERO_STATS = gql`
  query GetVoiceAgentHeroStats($filters: CallLogFiltersInput) {
    voiceAgentHeroStats(filters: $filters) {
      totalCalls
      outboundCalls
      inboundCalls
      totalBookings
      avgCallsPerBooking
    }
  }
`

export const GET_BOOKING_OUTCOMES = gql`
  query GetBookingOutcomes(
    $filters: BookingOutcomeFiltersInput!
    $groupByRecruiter: Boolean
  ) {
    getBookingOutcomes(filters: $filters, groupByRecruiter: $groupByRecruiter) {
      recruiterId
      recruiterName
      accepted
      noShow
      cancelled
      total
    }
  }
`

export const GET_VOICE_AGENT_CALL_HEATMAP = gql`
  query GetVoiceAgentCallHeatmap($filters: CallLogFiltersInput) {
    voiceAgentCallHeatmap(filters: $filters) {
      timezone
      cells {
        dayOfWeek
        hour
        calls
        voiceAgentCalls
        humanCalls
        bookings
      }
      summary {
        totalCalls
        offHoursCalls
        voiceAgentCalls
        offHoursVoiceAgentCalls
        humanCalls
        offHoursHumanCalls
        totalBookings
        offHoursBookings
      }
    }
  }
`
